import { render, staticRenderFns } from "./FiltersDrawer.vue?vue&type=template&id=3cbb96ee&scoped=true&"
import script from "./FiltersDrawer.vue?vue&type=script&lang=js&"
export * from "./FiltersDrawer.vue?vue&type=script&lang=js&"
import style0 from "./FiltersDrawer.vue?vue&type=style&index=0&id=3cbb96ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbb96ee",
  null
  
)

export default component.exports